import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
} from '@azure/msal-browser';

import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';

import { environment } from 'src/environments/environment';

// b2c Policies
const b2cPolicies = {
  authorities: {
    signUpSignIn: {
      authority: environment.signInAuthority,
    },
    resetPassword: {
      authority: environment.passwordResetAuthority,
    },
  },
};

// msal instance (singleton — must be initialized before any MSAL API is used)
let msalSingleton: IPublicClientApplication | null = null;
let msalInitPromise: Promise<void> | null = null;

function createMsalInstance(): IPublicClientApplication {
  const b2cDomain = b2cPolicies.authorities.signUpSignIn.authority.split('/')[2]; // Extract domain from URL

  return new PublicClientApplication({
    auth: {
      clientId: environment.clientId,
      redirectUri: environment.redirectUrl,
      authority: b2cPolicies.authorities.signUpSignIn.authority,
      knownAuthorities: [b2cDomain],
      postLogoutRedirectUri: environment.redirectUrl,
    },
    cache: {
      cacheLocation: 'localStorage',
    },
  });
}

export function MSALInstanceFactory(): IPublicClientApplication {
  if (!msalSingleton) {
    msalSingleton = createMsalInstance();
  }
  return msalSingleton;
}

/** Call once before bootstrap; safe to call multiple times. */
export function ensureMsalInitialized(): Promise<void> {
  const instance = MSALInstanceFactory();
  if (!msalInitPromise) {
    msalInitPromise = instance.initialize();
  }
  return msalInitPromise;
}

// masal interception
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  // protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']); // Prod environment. Uncomment to use.
  // environment.apiScopes)
  // protectedResourceMap.set(environment.apiUrl, ;
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

// msal guard config

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['openid', 'profile', 'offline_access']
    }
  };
}

/** Errors raised when redirect was already processed or the URL has no pending OAuth response. */
export function isBenignMsalRedirectError(err: unknown): boolean {
  const errStr = err ? String(err) : '';
  return (
    errStr.includes('state_mismatch') ||
    errStr.includes('state_not_found') ||
    errStr.includes('invalid_state') ||
    errStr.includes('no_cached_authority_error')
  );
}
